export default {
  tooltip_title: 'Cliquer pour copier',
  success: 'Copié !',
};
